/* Privacy-safe custom customer events for the Shopify Customer Events pixel. */
(function () {
  if (window.__clAnalytics) return;
  window.__clAnalytics = true;

  var roles = ['foundation', 'piece', 'extra', 'companion', 'art'];
  var steps = ['option_selected', 'product_selected', 'item_added', 'setup_added_to_cart', 'setup_saved'];
  var pageTypes = ['index', 'product', 'collection', 'page', 'article', 'blog', 'cart', 'search', 'list-collections', 'gift_card', '404', 'other'];
  var interactions = {
    saved_piece: ['save', 'unsave'],
    prototype: ['like', 'unlike'],
    idea_box: ['submit'],
    batch_wish: ['submit'],
    product_accordion: ['open', 'close']
  };
  var accordionSections = ['size_details', 'materials', 'how_it_sets_up', 'shipping_returns_care', 'questions_we_get'];
  var discoverySurfaces = ['home', 'main_menu', 'mobile_menu', 'collection', 'search', 'editorial', 'product_recommendation', 'ecosystem_entry', 'links_page'];
  var linksPlacementIds = {
    'top-stand': 'top_stand',
    'top-fa': 'top_fa',
    'top-mat': 'top_mat',
    'eco-piece': 'eco_piece',
    'eco-foundation': 'eco_foundation',
    'eco-all': 'eco_all',
    'wood': 'wood',
    'wood-all': 'wood_all',
    'imperfect': 'imperfect',
    'light': 'light',
    'wallpaper': 'wallpaper',
    'wallpaper-all': 'wallpaper_all',
    'print': 'print',
    'print-all': 'print_all',
    'keycaps': 'keycaps',
    'keycaps-all': 'keycaps_all',
    'builder': 'builder',
    'affiliate': 'affiliate'
  };
  var destinationTypes = ['product', 'collection', 'builder', 'content'];
  var accountActions = [
    'account_entry', 'points_page_entry', 'points_panel_open', 'points_panel_close',
    'earning_action_click', 'review_action_click',
    'referral_action_click', 'reward_redeem_intent', 'reward_redemption_success'
  ];
  var accountSurfaces = ['header', 'content', 'points_panel', 'account', 'rewards', 'cart'];
  // out_of_stock: Shopify's 422 for "not enough stock" (sold out, or the cart already holds every piece there is).
  // It used to be counted as validation, so a stock limit and a broken form looked the same in GA4 (Oct 27 2026).
  var cartFailureCategories = ['validation', 'out_of_stock', 'rejected', 'server', 'network'];
  var STOCK_ERROR = /quantity|in your cart|to the cart|can't add|cannot add|sold out|out of stock/i;
  var optionGroups = {
    color: ['color', 'colour'],
    wood: ['wood', 'wood tone', 'wood type'],
    material: ['material'],
    size: ['size'],
    finish: ['finish'],
    profile: ['profile', 'keycap profile'],
    layout: ['layout', 'keyboard layout'],
    art: ['art', 'artwork', 'design'],
    format: ['format'],
    style: ['style'],
    type: ['type'],
    tray_count: ['tray count']
  };
  var optionValues = {
    ash: 'ash', beige: 'beige', black: 'black', blue: 'blue', brown: 'brown',
    cherry: 'cherry', cream: 'cream', green: 'green', grey: 'grey',
    ivory: 'cream', lavender: 'purple', maple: 'maple', natural: 'natural',
    navy: 'blue', oak: 'oak', olive: 'green', orange: 'orange', pink: 'pink',
    pistachio: 'green', plum: 'purple', purple: 'purple', red: 'red', rose: 'pink', 'rose gold': 'pink',
    'dusty blush': 'pink',
    sakura: 'pink', 'sakura pink': 'pink', sage: 'green', walnut: 'walnut',
    white: 'white', yellow: 'yellow', 'white oak': 'oak', 'red oak': 'oak',
    'light wood': 'light', 'medium wood': 'medium', 'dark wood': 'dark',
    light: 'light', medium: 'medium', dark: 'dark', mini: 'mini', small: 'small',
    large: 'large', compact: 'small', standard: 'standard', full: 'full',
    '60%': '60_percent', '65%': '65_percent', '75%': '75_percent',
    '80%': '80_percent', '96%': '96_percent', '100%': '100_percent',
    ansi: 'ansi', iso: 'iso', cherry_profile: 'cherry', 'cherry profile': 'cherry',
    oem: 'oem', 'oem profile': 'oem', xda: 'xda', 'xda profile': 'xda',
    sa: 'sa', 'sa profile': 'sa', mt3: 'mt3', 'mt3 profile': 'mt3',
    spring: 'spring', summer: 'summer', autumn: 'autumn', fall: 'autumn',
    winter: 'winter', 'all year': 'all_year', matte: 'matte', glossy: 'glossy',
    satin: 'satin', smooth: 'smooth', textured: 'textured', metal: 'metal',
    acrylic: 'acrylic', silicone: 'silicone', leather: 'leather', cork: 'cork',
    glass: 'glass', paper: 'paper', '1': 'one', '2': 'two', '3': 'three'
  };
  var ecosystemPaths = [
    '/pages/build-ecosystem',
    '/pages/build-your-cozy-desk-setup'
  ];
  var blogActions = [
    'like',
    'unlike',
    'comment_submit_intent',
    'share_click',
    'share_web_success',
    'share_clipboard_copied',
    'share_mailto_handoff',
    'read_complete'
  ];

  function pageType() {
    var match = document.body && document.body.className.match(/\btemplate-([a-z0-9_-]+)/);
    var value = match && match[1];
    return pageTypes.indexOf(value) > -1 ? value : 'other';
  }

  function optionGroup(value) {
    if (typeof value !== 'string' || value.length > 40) return null;
    var name = value.trim().toLowerCase().replace(/\s+/g, ' ');
    var names = Object.keys(optionGroups);
    for (var i = 0; i < names.length; i++) {
      if (optionGroups[names[i]].indexOf(name) > -1) return names[i];
    }
    return null;
  }

  function optionValue(value) {
    if (typeof value !== 'string' || value.length > 60) return 'other';
    var name = value.trim().toLowerCase()
      .split(' — ')[0].split(' · ')[0].split(' (')[0]
      .replace(/\s+/g, ' ');
    return optionValues[name] || 'other';
  }

  function catalogText(value, limit) {
    if (typeof value !== 'string' || value.length === 0 || value.length > limit || /[\u0000-\u001f\u007f]/.test(value)) return null;
    if (/https?:\/\//i.test(value) || /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(value) ||
      /(?:^|\D)\+?\d[\d\s().-]{6,}\d(?:\D|$)/.test(value)) return null;
    return value;
  }

  function addVariantOptionFields(data, optionNames, options) {
    if (!Array.isArray(optionNames) || !Array.isArray(options)) return;
    for (var i = 0; i < Math.min(optionNames.length, options.length, 3); i++) {
      var name = catalogText(optionNames[i], 40);
      var value = catalogText(options[i], 80);
      if (name && value) {
        data['variant_option_' + (i + 1) + '_name'] = name;
        data['variant_option_' + (i + 1)] = value;
      }
    }
  }

  function resolvedVariantSelected(details) {
    if (!details || !/^\d{1,30}$/.test(String(details.product_id || '')) ||
      !/^[a-z0-9-]{1,80}$/.test(String(details.product_handle || '')) ||
      !/^[A-Za-z0-9_-]{1,80}$/.test(String(details.variant_id || '')) ||
      (details.availability !== 'available' && details.availability !== 'sold_out') ||
      ['product_page', 'ecosystem_builder', 'product_stack', 'links_page_builder', 'quick_view'].indexOf(details.selection_surface) === -1) return;
    var variantTitle = catalogText(details.variant_title, 100);
    if (!variantTitle) return;
    var data = {
      schema_version: 2,
      product_id: String(details.product_id),
      product_handle: details.product_handle,
      variant_id: String(details.variant_id),
      variant_title: variantTitle,
      availability: details.availability,
      selection_surface: details.selection_surface
    };
    addVariantOptionFields(data, details.option_names, details.options);
    if (details.builder_type === 'ecosystem' || details.builder_type === 'product_stack') data.builder_type = details.builder_type;
    if (roles.indexOf(details.product_role) > -1) data.product_role = details.product_role;
    var group = optionGroup(details.option_group);
    if (group) {
      data.option_group = group;
      data.option_value = optionValue(details.option_value);
    }
    publish('variant_selected', data);
  }

  function safeRoutePath(value) {
    if (typeof value !== 'string' || value.length > 160) return null;
    var path = value.split(/[?#]/)[0];
    if (path === '/') return path;
    if (!/^\/(?:blogs\/[a-z0-9-]+(?:\/[a-z0-9-]+)?|pages\/[a-z0-9-]+|products\/[a-z0-9-]+|collections\/[a-z0-9-]+|cart|search|policies\/[a-z0-9-]+)\/?$/i.test(path)) return null;
    if (/@|(?:\+?\d[\d\s().-]{7,}\d)/.test(path)) return null;
    return path.replace(/\/$/, '').toLowerCase();
  }

  function sourceCategory(path) {
    if (typeof path !== 'string') return null;
    if (path === '/') return 'home';
    if (/^\/blogs\/[a-z0-9-]+$/i.test(path)) return 'blog';
    if (/^\/blogs\/[a-z0-9-]+\/[a-z0-9-]+$/i.test(path)) return 'article';
    var page = path.match(/^\/pages\/([a-z0-9-]+)$/i);
    if (!page) return null;
    if (page[1] === 'care' || page[1].indexOf('care-guide') === 0) return 'care';
    if (page[1] === 'reviews') return 'reviews';
    if (page[1] === 'ecosystem-story' || page[1] === 'the-ecosystem') return 'ecosystem';
    if (page[1] === 'build-ecosystem' || page[1] === 'build-your-cozy-desk-setup') return null;
    return 'editorial';
  }

  function destinationCategory(path) {
    if (/^\/products\/[a-z0-9-]+$/i.test(path)) return 'product';
    if (/^\/collections\/[a-z0-9-]+$/i.test(path)) return 'collection';
    if (ecosystemPaths.indexOf(path) > -1) return 'builder';
    if (/^\/(?:pages\/[a-z0-9-]+|blogs\/[a-z0-9-]+(?:\/[a-z0-9-]+)?)$/i.test(path)) return 'content';
    return null;
  }

  function sourceHandle(path, category) {
    if (category === 'home') return null;
    var handle = path.split('/').pop();
    return /^[a-z0-9-]{1,80}$/.test(handle) ? handle : null;
  }

  function publish(name, data) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;

    try {
      var result = analytics.publish('cozyleigh:' + name, data);
      if (result && typeof result.catch === 'function') {
        result.catch(function (error) {
          if (window.console && console.warn) console.warn('Cozyleigh analytics event was not published:', error);
        });
      }
    } catch (error) {
      if (window.console && console.warn) console.warn('Cozyleigh analytics event was not published:', error);
    }
  }

  function builderType() {
    if (document.querySelector('[data-be]')) return 'ecosystem';
    if (document.querySelector('[data-stack-builder]')) return 'product_stack';
    return null;
  }

  function builderStep(step, role, optionIndex, itemCount, optionName, selectedValue) {
    if (steps.indexOf(step) === -1) return;
    var data = { step: step };
    var type = builderType();
    if (type) data.builder_type = type;
    if (roles.indexOf(role) > -1) data.product_role = role;
    if (Number.isInteger(optionIndex) && optionIndex >= 0 && optionIndex < 10) data.option_index = optionIndex + 1;
    if (Number.isInteger(itemCount) && itemCount >= 0 && itemCount <= 100) data.item_count = itemCount;
    if (step === 'option_selected') {
      var group = optionGroup(optionName);
      if (group) {
        data.option_group = group;
        data.option_value = optionValue(selectedValue);
      }
    }
    publish('builder_step', data);
  }

  function builderVariantSelected(details) {
    resolvedVariantSelected(details);
  }

  function componentInteraction(component, action, handle, section) {
    if (!interactions[component] || interactions[component].indexOf(action) === -1) return;
    var data = { component: component, action: action };
    if ((component === 'saved_piece' || component === 'product_accordion') && typeof handle === 'string' && /^[a-z0-9-]{1,80}$/.test(handle)) {
      data.product_handle = handle;
    }
    // which fold on a product page: a fixed list of ids, never the row's own text
    if (component === 'product_accordion') {
      if (accordionSections.indexOf(section) === -1) return;
      data.section = section;
    }
    publish('component_interaction', data);
  }

  function blogEngagement(action, handle) {
    if (blogActions.indexOf(action) === -1 || typeof handle !== 'string' || !/^[a-z0-9-]{1,80}$/.test(handle)) return;
    var path = safeRoutePath(window.location.pathname);
    if (!path || !/^\/blogs\/[a-z0-9-]+\/[a-z0-9-]+$/.test(path) || path.split('/').pop() !== handle) return;
    publish('blog_engagement', { action: action, article_handle: handle });
  }

  function accountInteraction(action, surface, stage) {
    if (accountActions.indexOf(action) === -1) return;
    var data = { action: action };
    if (accountSurfaces.indexOf(surface) > -1) data.surface = surface;
    if (stage === 'select' || stage === 'confirm') data.stage = stage;
    var path = safeRoutePath(window.location.pathname);
    if (path) data.source_page_path = path;
    publish('account_interaction', data);
  }

  function addToCartFailure(category, type) {
    if (cartFailureCategories.indexOf(category) === -1) return;
    // The theme's product form doesn't say which builder it is in, so failures on the setup builder pages were dropped.
    if (!type) type = builderType();
    var path = safeRoutePath(window.location.pathname);
    var handle = path && path.match(/^\/products\/([a-z0-9-]+)$/);
    var data = { failure_category: category };
    if (handle) data.product_handle = handle[1];
    if (type === 'product_stack' && handle) data.builder_type = type;
    else if (type === 'ecosystem' && !handle) data.builder_type = type;
    if (!handle && !data.builder_type) return;
    publish('add_to_cart_failure', data);
  }

  // responseText: Shopify's error body, read only to tell a stock limit from bad input; never sent anywhere.
  function cartFailureCategory(status, responseText) {
    var code = Number(status);
    if (!Number.isFinite(code) || code === 0) return 'network';
    if (code === 422) return typeof responseText === 'string' && STOCK_ERROR.test(responseText) ? 'out_of_stock' : 'validation';
    if (code >= 400 && code < 500) return 'rejected';
    if (code >= 500 && code < 600) return 'server';
    return null;
  }

  // "Goes with it" suggestions (assets/cozyleigh-added-pairs.js, snippets/cl-cart-recs): shown once per list, and
  // each Add. The pixel maps these to GA4's item-list events and tags the add_to_cart that follows an Add.
  var recActions = ['shown', 'add'];
  var recLists = ['added_popup', 'cart_recs', 'account_recs'];
  var recRules = ['companion', 'stack_another', 'keycap_kit', 'mat_setup', 'imperfectly_perfect', 'shopify_recs', 'ship_gap'];
  function recommendation(action, list, items) {
    if (recActions.indexOf(action) === -1 || recLists.indexOf(list) === -1 || !Array.isArray(items)) return;
    var clean = [];
    items.slice(0, 8).forEach(function (item, index) {
      if (!item) return;
      var variantId = String(item.variant_id || '');
      var productId = String(item.product_id || '');
      if (!/^\d{1,30}$/.test(variantId) || recRules.indexOf(item.rule) === -1) return;
      var row = { variant_id: variantId, rule: item.rule, position: Number.isInteger(item.position) && item.position > 0 && item.position <= 20 ? item.position : index + 1 };
      if (/^\d{1,30}$/.test(productId)) row.product_id = productId;
      if (typeof item.product_handle === 'string' && /^[a-z0-9-]{1,80}$/.test(item.product_handle)) row.product_handle = item.product_handle;
      clean.push(row);
    });
    if (clean.length) publish('recommendation', { action: action, list: list, items: clean });
  }

  window.clAnalytics = {
    recommendation: recommendation,
    builderStep: builderStep,
    builderVariantSelected: builderVariantSelected,
    resolvedVariantSelected: resolvedVariantSelected,
    componentInteraction: componentInteraction,
    blogEngagement: blogEngagement,
    accountInteraction: accountInteraction,
    addToCartFailure: addToCartFailure,
    cartFailureCategory: cartFailureCategory
  };

  function variantIntentOwner(picker) {
    return picker.closest('.js-quickbuy') || picker.closest('.product-area') || picker.parentElement || picker;
  }

  function variantIntentKey(picker) {
    return [picker.getAttribute('data-section-id') || '', picker.getAttribute('data-cl-product-handle') || ''].join(':');
  }

  function linkSurface(link, sourcePath, destinationPath) {
    if (link.closest('.section-header, .shopify-section-group-header-group, header, [data-section-type="header"]')) {
      return window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 'mobile_menu' : 'main_menu';
    }
    if (sourcePath === '/pages/links' && link.closest('.cl-bio')) return 'links_page';
    if (link.closest('#search-modal, .cl-srch-page, .cl-srch__soldout')) return 'search';
    if (link.closest('.product-recommendations, product-recommendations, [data-section-type="product-recommendations"], .cl-pairs, [data-cl-recs]')) return 'product_recommendation';
    if (/^\/collections\//.test(sourcePath) && link.closest('.product-block, .product-item')) return 'collection';
    if (sourcePath === '/search' && link.closest('.product-block, .product-item')) return 'search';
    if (sourcePath === '/' && link.closest('[data-section-type]')) return 'home';
    if (destinationCategory(destinationPath) === 'builder') return 'ecosystem_entry';
    if (sourceCategory(sourcePath)) return 'editorial';
    return null;
  }

  function placementId(link, surface) {
    var explicit = link.getAttribute('data-cl-placement');
    if (typeof explicit === 'string' && /^[a-z0-9_]{1,60}$/.test(explicit)) return explicit;
    if (surface === 'links_page') {
      var destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch (error) {
        destination = null;
      }
      var content = destination && destination.searchParams.get('utm_content');
      var placement = linksPlacementIds[content];
      if (placement) {
        var card = link.closest('.cl-bio__card');
        var row = card && card.closest('.cl-bio__row');
        var cards = row && row.querySelectorAll('.cl-bio__card');
        var cardIndex = cards ? Array.prototype.indexOf.call(cards, card) + 1 : 0;
        return 'links_' + placement + (cardIndex > 0 && cardIndex <= 20 ? '_card_' + cardIndex : '');
      }
      if (link.closest('.cl-bio__btns')) return 'links_top_buttons';
      if (link.matches('#build-toggle, .cl-eco__toggle')) return 'links_builder_toggle';
      if (link.closest('.cl-eco__more')) return 'links_builder_product_details';
      if (link.closest('.cl-bio__join')) return 'links_signup';
      if (link.closest('.cl-bio__aff')) return 'links_affiliate';
      if (link.closest('.cl-bio__social')) return 'links_social';
      if (link.closest('.cl-bio__links')) return 'links_footer';
      return 'links_content_link';
    }
    if (surface === 'main_menu' || surface === 'mobile_menu') return surface + '_link';
    if (surface === 'product_recommendation') return 'product_recommendation_card';
    if (surface === 'collection' || surface === 'search') {
      var card = link.closest('.product-block, .product-item');
      if (!card && surface === 'search') return 'search_link';
      var section = card && card.closest('[data-section-type]');
      var cards = section && section.querySelectorAll('.product-block, .product-item');
      var index = cards ? Array.prototype.indexOf.call(cards, card) + 1 : 0;
      return surface + (surface === 'search' ? '_result' : '') + '_card_' + (index || 1);
    }
    if (surface === 'home') {
      var homeCard = link.closest('.product-block, .product-item');
      if (homeCard) {
        var cardSection = homeCard.closest('[data-section-type]');
        var cardList = cardSection && cardSection.querySelectorAll('.product-block, .product-item');
        var cardIndex = cardList ? Array.prototype.indexOf.call(cardList, homeCard) + 1 : 0;
        return 'home_product_card_' + (cardIndex || 1);
      }
      var homeSection = link.closest('[data-section-type]');
      var type = homeSection && homeSection.getAttribute('data-section-type');
      type = typeof type === 'string' ? type.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '') : '';
      if (type && /^[a-z0-9_]{1,40}$/.test(type)) return 'home_' + type;
      return 'home_section';
    }
    return surface + '_content_link';
  }

  function emitDiscoveryClick(link, sourcePath, destinationPath, destinationType, surface) {
    if (discoverySurfaces.indexOf(surface) === -1 || destinationTypes.indexOf(destinationType) === -1) return;
    var data = {
      source_surface: surface,
      source_page_path: sourcePath,
      placement_id: placementId(link, surface),
      destination_type: destinationType,
      destination_path: destinationPath
    };
    var handle = destinationPath.match(/^\/products\/([a-z0-9-]+)$/);
    if (destinationType === 'product' && handle) {
      data.product_handle = handle[1];
      var card = link.closest('[data-product-id], [data-product_id]');
      var id = card && (card.getAttribute('data-product-id') || card.getAttribute('data-product_id'));
      if (typeof id === 'string' && /^\d{1,30}$/.test(id)) data.product_id = id;
    }
    // The order notes (snippets/cl-order-source) keep this visit's clicks too, so each order can say how it was found:
    // home page, menu, a set, search... (Oct 27 2026). Only the fixed ids above are passed, never link text.
    if (typeof window.clOrderJourneyClick === 'function') {
      try { window.clOrderJourneyClick(surface, data.placement_id, sourcePath, destinationPath); } catch (error) {}
    }
    publish('product_discovery_click', data);
  }

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target;
    var link = target && target.closest ? target.closest('a[href]') : null;
    if (!link) return;
    var sourcePath = safeRoutePath(window.location.pathname);
    if (!sourcePath) return;

    var destination;
    try {
      destination = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }
    if (destination.origin !== window.location.origin) return;
    var destinationPath = safeRoutePath(destination.pathname);
    if (!destinationPath) {
      if (/^\/account(?:\/|$)/i.test(destination.pathname)) {
        var accountSurface = link.closest('.section-header, header, [data-section-type="header"]') ? 'header' : 'content';
        accountInteraction('account_entry', accountSurface);
      }
      return;
    }
    if (destinationPath === sourcePath && destination.hash) return;
    if (/^\/pages\/rewards$/i.test(destinationPath)) {
      var pointsSurface = link.closest('.section-header, header, [data-section-type="header"]') ? 'header' : 'content';
      accountInteraction('points_page_entry', pointsSurface);
    }
    var category = destinationCategory(destinationPath);
    if (!category) return;
    var surface = linkSurface(link, sourcePath, destinationPath);
    if (surface) emitDiscoveryClick(link, sourcePath, destinationPath, category, surface);
  });

  var pendingVariantIntents = new WeakMap();
  document.addEventListener('change', function (event) {
    var control = event.target;
    var picker = control && control.closest ? control.closest('variant-picker') : null;
    var path = safeRoutePath(window.location.pathname);
    if (!picker || !path) return;
    var area = picker.closest('.product-area') || picker.closest('.js-quickbuy') || picker.parentElement;
    var idInput = area && area.querySelector('[name="id"]');
    if (!idInput || !control.matches || !control.matches('input, select')) return;
    var groupElement = control.closest('fieldset');
    var groupLabel = groupElement && (groupElement.querySelector('legend') || groupElement.querySelector('[role="group"]'));
    var owner = variantIntentOwner(picker);
    var ownerIntents = pendingVariantIntents.get(owner);
    if (!ownerIntents) {
      ownerIntents = Object.create(null);
      pendingVariantIntents.set(owner, ownerIntents);
    }
    ownerIntents[variantIntentKey(picker)] = {
      previous_variant_id: String(idInput.value || '').split('/').pop(),
      option_name: groupLabel && (groupLabel.getAttribute('aria-label') || groupLabel.textContent),
      option_value: control.value,
      expires_at: Date.now() + 10000
    };
  }, true);

  document.addEventListener('on:variant:change', function (event) {
    var picker = event.target;
    var variant = event.detail && event.detail.variant;
    if (!picker || !picker.matches || !picker.matches('variant-picker') || !variant || variant.id == null) return;
    var variantId = String(variant.id).split('/').pop();
    if (!/^[A-Za-z0-9_-]{1,80}$/.test(variantId)) return;
    var path = safeRoutePath(window.location.pathname);
    var owner = variantIntentOwner(picker);
    var ownerIntents = pendingVariantIntents.get(owner);
    var intentKey = variantIntentKey(picker);
    var intent = ownerIntents && ownerIntents[intentKey];
    if (ownerIntents) delete ownerIntents[intentKey];
    if (!path || !intent || intent.expires_at < Date.now() || intent.previous_variant_id === variantId) return;
    var selectionSurface = picker.closest('.js-quickbuy') ? 'quick_view' :
      (picker.closest('[data-be]') ? 'ecosystem_builder' :
        (/^\/products\/[a-z0-9-]+$/.test(path) ? 'product_page' : null));
    if (!selectionSurface) return;
    var productHandle = picker.getAttribute('data-cl-product-handle');
    if (!productHandle || !/^[a-z0-9-]{1,80}$/.test(productHandle)) return;
    var productId = picker.getAttribute('data-cl-product-id');
    var names;
    try { names = JSON.parse(picker.getAttribute('data-cl-option-names') || '[]'); } catch (error) { names = []; }
    resolvedVariantSelected({
      product_handle: productHandle,
      product_id: productId,
      variant_id: variantId,
      variant_title: variant.title,
      option_names: names,
      options: variant.options,
      availability: variant.available === false ? 'sold_out' : 'available',
      selection_surface: selectionSurface,
      option_group: intent.option_name,
      option_value: intent.option_value
    });
  });

  document.addEventListener('invalid', function (event) {
    var control = event.target;
    var form = control && control.closest ? control.closest('.product-detail__form, form[action*="/cart/add"]') : null;
    var path = safeRoutePath(window.location.pathname);
    if (!form || !path || !/^\/products\/([a-z0-9-]+)$/.test(path)) return;
    if (form.__clInvalidPending) return;
    form.__clInvalidPending = true;
    window.setTimeout(function () {
      form.__clInvalidPending = false;
      addToCartFailure('validation');
    }, 0);
  }, true);

  // Opening the phone menu: one event per open, so "menu opened, then a piece" can be read as a rate.
  // Capture phase, so the theme's own handler cannot swallow it. Closing the menu (it is already open) is not counted,
  // and a page without the menu button simply never matches.
  document.addEventListener('click', function (event) {
    if (event.button !== 0) return;
    var target = event.target;
    var toggle = target && target.closest ? target.closest('[data-modal-nav-toggle]') : null;
    if (!toggle) return;
    var menu = document.getElementById('page-menu');
    if (menu && menu.classList.contains('reveal')) return;
    if (document.body.classList.contains('modal-active')) return;
    var sourcePath = safeRoutePath(window.location.pathname);
    if (!sourcePath) return;
    publish('menu_open', { source_page_path: sourcePath });
  }, true);

  document.addEventListener('toggle', function (event) {
    var target = event.target;
    var details = target && target.matches && target.matches('details') ? target : null;
    if (!details || !details.open || details.getAttribute('data-cl-analytics-expanded') === 'true') return;
    var identity = [details.id, details.getAttribute('data-section-type'), details.className].join(' ').toLowerCase();
    var category = /size|fit|measure/.test(identity) ? 'size' :
      /compat|device/.test(identity) ? 'compatibility' :
      /care/.test(identity) ? 'care' :
      /ship|deliver/.test(identity) ? 'shipping' :
      /return|refund/.test(identity) ? 'returns' :
      /earn|reward|point/.test(identity) ? 'earning_rule' :
      /faq|accordion|help/.test(identity) ? 'faq' : null;
    if (!category) return;
    details.setAttribute('data-cl-analytics-expanded', 'true');
    publish('info_expand', { info_category: category, page_type: pageType() });
  }, true);

  var activeSeconds = 0;
  var lastActivity = Date.now();
  var idleTimeout = 30 * 1000;
  var timeMilestones = [15, 60];
  var sentTimeMilestones = {};
  var scrollMilestones = [25, 50, 75, 90];
  var sentScrollMilestones = {};

  function activeTick() {
    if (document.visibilityState === 'hidden' || Date.now() - lastActivity > idleTimeout) return;
    activeSeconds++;
    for (var i = 0; i < timeMilestones.length; i++) {
      var seconds = timeMilestones[i];
      if (activeSeconds >= seconds && !sentTimeMilestones[seconds]) {
        sentTimeMilestones[seconds] = true;
        publish('page_engaged', { engagement_seconds: seconds, page_type: pageType() });
      }
    }
  }

  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (name) {
    window.addEventListener(name, function () { lastActivity = Date.now(); }, { passive: name !== 'keydown' });
  });

  // One "a person is here" signal per page, from real input: a tap, click, key, scroll wheel, or a mouse
  // moving a little. Script-made events (isTrusted false) don't count. The GA4 pixel holds page views
  // until it sees this, so crawlers that never touch the page are never counted.
  var humanSent = false;
  var mouseTravel = 0;
  var lastPointer = null;
  var humanEvents = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'pointermove'];

  function onHumanInput(event) {
    if (humanSent || !event || event.isTrusted !== true) return;
    if (event.type === 'pointermove') {
      if (event.pointerType !== 'mouse') return;
      if (lastPointer) mouseTravel += Math.abs(event.clientX - lastPointer.x) + Math.abs(event.clientY - lastPointer.y);
      lastPointer = { x: event.clientX, y: event.clientY };
      if (mouseTravel < 40) return;
    }
    humanSent = true;
    humanEvents.forEach(function (name) { window.removeEventListener(name, onHumanInput, true); });
    publish('human_signal', { signal: event.type === 'pointermove' ? 'mouse' : event.type === 'wheel' ? 'scroll' : event.type === 'keydown' ? 'key' : 'tap' });
  }

  humanEvents.forEach(function (name) {
    window.addEventListener(name, onHumanInput, { capture: true, passive: true });
  });

  function recordScrollDepth() {
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable < 200) return;
    var depth = Math.min(100, Math.round((window.scrollY / scrollable) * 100));
    for (var i = 0; i < scrollMilestones.length; i++) {
      var milestone = scrollMilestones[i];
      if (depth >= milestone && !sentScrollMilestones[milestone]) {
        sentScrollMilestones[milestone] = true;
        publish('scroll_depth', { depth_percent: milestone, page_type: pageType() });
      }
    }
  }

  window.setInterval(activeTick, 1000);
  window.addEventListener('scroll', recordScrollDepth, { passive: true });
  window.addEventListener('resize', recordScrollDepth);

  var activeType = builderType();
  if (activeType) publish('builder_entry', { page_type: pageType(), builder_type: activeType });
  if (document.querySelector('[data-cl-empty-search="true"]')) publish('empty_search', { page_type: 'search' });
})();
